import React from 'react';
import QuadProd from './QuadProd';
import { DissetacoesDB } from '../DissetacoesDB';

function Dissert() {
  return (
    <section className="services">
            <div className="container">
                <div className="row">
                    <h2>Dissertações</h2>
                    
                    {
                    DissetacoesDB.map((user, i) => {
                    return (
                        <QuadProd  
                        key={i} 
                        titulo={DissetacoesDB[i].titulo} 
                        meio={DissetacoesDB[i].meio}
                        link={DissetacoesDB[i].link} 
                        data={DissetacoesDB[i].data} 
                        text1={DissetacoesDB[i].text1} 
                        text2={DissetacoesDB[i].text2} 
                        icon={DissetacoesDB[i].icon}
                        status={DissetacoesDB[i].status}
                        />
                        );
                    })
                  }

                </div>
              </div>
    </section>
    

  );
}

export default Dissert;